import React from 'react';
import { useOutletContext } from 'react-router-dom';
import WidgetDrawer from './drawer';

/**
 * Wrapper component for WidgetDrawer that receives props from the parent layout
 * via React Router's outlet context. This ensures all WidgetDrawer instances
 * receive the necessary props for proper functionality.
 */
const WidgetDrawerWrapper = ({ view }) => {
  // Get props from the parent layout via outlet context
  const context = useOutletContext();
  
  if (!context) {
    // Fallback if context is not available
    console.warn('WidgetDrawerWrapper: No context provided from parent layout');
    return <WidgetDrawer view={view} />;
  }

  const {
    highlightDesc,
    modeMobile,
    clickThru,
    sidebarWidth,
    visibleScreen,
    flags,
  } = context;

  return (
    <WidgetDrawer
      highlightDesc={highlightDesc}
      view={view}
      modeMobile={modeMobile}
      clickThru={clickThru}
      sidebarWidth={sidebarWidth}
      visibleScreen={visibleScreen}
      flags={flags}
    />
  );
};

export default WidgetDrawerWrapper;
